import { useEffect, useState } from "react";

const KEY = "theme";
export const THEMES = [
  { key: "light", label: "Luminos", dot: "#F6F4EF" },
  { key: "dark", label: "Întunecat", dot: "#12141C" },
  { key: "glass", label: "Liquid Glass", dot: "linear-gradient(135deg,#7C3AED,#0EA5E9,#EC4899)" },
  { key: "glass-light", label: "Liquid Glass luminos", dot: "linear-gradient(135deg,#C7D2FE,#BAE6FD,#FBCFE8)" },
];
const DEF = "theme_default";
const valid = (t) => THEMES.some((x) => x.key === t);
const current = () => [localStorage.getItem(KEY), localStorage.getItem(DEF), "glass"].find(valid);
export const isLight = (t) => t === "light" || t === "glass-light";

const apply = (t) => {
  const el = document.documentElement;
  el.classList.toggle("light", isLight(t));
  el.classList.toggle("dark", !isLight(t));
  el.classList.toggle("glass", t.startsWith("glass"));
  const meta = { light: "#FFFFFF", dark: "#0B0D13", glass: "#0B0A1A", "glass-light": "#EEF2FF" }[t];
  document.querySelectorAll('meta[name="theme-color"]').forEach((m) => { m.content = meta; });
  window.dispatchEvent(new Event("themechange"));
};

export const initTheme = () => {
  if (!localStorage.getItem("theme_forced_v1")) { localStorage.removeItem(KEY); localStorage.setItem("theme_forced_v1", "1"); }
  apply(current());
  fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/theme`).then((r) => r.json()).then((d) => {
    if (valid(d.default_theme) && d.default_theme !== localStorage.getItem(DEF)) {
      if (localStorage.getItem(DEF)) localStorage.removeItem(KEY);
      localStorage.setItem(DEF, d.default_theme); apply(current());
    }
  }).catch(() => {});
};
export const setTheme = (t) => { localStorage.setItem(KEY, t); apply(t); };
export const setDefaultThemeLocal = (t) => { localStorage.setItem(DEF, t); localStorage.removeItem(KEY); apply(current()); };

export function useTheme() {
  const [theme, setT] = useState(current);
  useEffect(() => {
    const onChange = () => setT(current());
    window.addEventListener("themechange", onChange);
    return () => window.removeEventListener("themechange", onChange);
  }, []);
  return theme;
}
